import React from 'react';
import Layout from '../layout/Layout';
import Container from '../ui/Container';
import Button from '../ui/Button';
import Sparkle from '../ui/Sparkle';

/** Generic confirmation / status screen. Used by /shopify-sync-success. */
const VARIANTS = {
  shopify: {
    eyebrow: 'All done',
    title: 'Synchronisation successful.',
    text: 'Your Shopify sync completed successfully. You can safely close this window.',
    primary: { label: 'Go to Shopstar', href: '/' },
    secondary: null,
  },
};

const ThankYou = ({ variant = 'shopify' }) => {
  const v = VARIANTS[variant] || VARIANTS.shopify;
  return (
    <Layout>
      <section className="relative overflow-hidden bg-sky min-h-[70vh] grid place-items-center text-center py-20 md:py-28">
        <Sparkle size={140} color="#95a8e6" className="pointer-events-none absolute top-[10%] left-[10%] opacity-25 hidden sm:block" />
        <Sparkle size={64} color="#ffb442" className="pointer-events-none absolute bottom-[14%] right-[12%] opacity-90" />
        <Container className="relative max-w-[46ch]">
          <span className="inline-grid place-items-center w-[88px] h-[88px] rounded-full bg-white text-amber shadow-card mb-7">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
          <span className="block text-xs font-extrabold uppercase tracking-[0.14em] text-ink mb-3.5">{v.eyebrow}</span>
          <h1 className="text-h1 font-extrabold text-ink">{v.title}</h1>
          <p className="mt-5 mx-auto max-w-[40ch] text-lead text-body">{v.text}</p>
          <div className="mt-9 flex flex-wrap gap-3.5 justify-center">
            <Button href={v.primary.href}>{v.primary.label}</Button>
            {v.secondary && <Button href={v.secondary.href} variant="secondary" icon={false}>{v.secondary.label}</Button>}
          </div>
        </Container>
      </section>
    </Layout>
  );
};

export default ThankYou;
